import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-cookie-policy',
  imports: [
    RouterLink
  ],
  templateUrl: './cookie-policy.html',
  styleUrl: './cookie-policy.scss'
})
export class CookiePolicy {

}
